import styled from 'theme';

export const UploadFieldInputWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;

  input {
    display: none;
  }

  > * {
    height: 2rem;
  }
`;

export const UploadedFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${props => props.theme.variables.customColors.lightNavy};
  width: 100%;

  span {
    max-width: 10rem;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
`;

export const ErrorMessage = styled.p`
  margin-top: 0.2187rem;
  color: ${props => props.theme.variables.colors.red};
  font-size: ${props => props.theme.variables.fonts.size.smaller1};
`;

export const DeleteButton = styled.span`
  cursor: pointer;
  color: ${props => props.theme.variables.colors.red};
  font-size: 0.75rem;
`;
